/*
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-08-22 16:12:39
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-09-19 23:40:32
 */
import axios from 'axios'
import store from '@/store'
import { Notify } from 'vant'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000
})

service.interceptors.request.use(
  (config) => {
    if (config.url === '/upload_base64_shop_img') {
      config.timeout = 1000 * 3
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  (error) => {
    Notify(error.message)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code !== 0) {
      if (res.code === 1000) {
        store.dispatch('setToken', '')
      } else {
        Notify(res.msg)
        return Promise.reject(res.msg || 'Error')
      }
    } else {
      return res
    }
  },
  (error) => {
    // Notify(error.message)
    return Promise.reject(error)
  }
)

export default service
